import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import "../../../ComponentsCss/AdminPanel/PfReport.css";
import { GlobalContext } from "../../../../context/GlobalContext/GlobalContext";
import { usePopup } from "../../../../context/popup-context/Popup";
import { Popup } from "../../../Utils/Popup/Popup";

const EmployeeMasterData = () => {
  const { globalData } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [companyCode, setCompanyCode] = useState(
    globalData?.userInfo?.companyCode || "",
  );

  const [statuses, setStatuses] = useState({
    active: true, // Default to active checked
    inactive: false,
    dummy: false,
  });

  const { showPopup, setShowPopup, setMessage: setPopupMessage } = usePopup();

  useEffect(() => {
    if (!message) return undefined;

    const timer = setTimeout(() => {
      setMessage("");
    }, 4000);

    return () => clearTimeout(timer);
  }, [message]);

  const mockCompanies = [
    { code: 1, name: "Daksh" },
    { code: 2, name: "MIT Pvt Ltd" },
    { code: 3, name: "Daksh Global Pvt Ltd" },
    { code: 4, name: "Marche Ricche pri ltd" },
    { code: 5, name: "VNG Enterprises Pvt. Ltd" },
  ];

  // Handle Checkbox Changes
  const handleStatusChange = (e) => {
    const { name, checked } = e.target;
    setStatuses((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleDownload = async () => {
    // Get all selected statuses into an array (e.g., ['active', 'dummy'])
    const selectedStatuses = Object.keys(statuses).filter(
      (key) => statuses[key],
    );

    if (!companyCode || selectedStatuses.length === 0) {
      const msg = "Please select a Company and at least one Employee Status.";
      setMessage(msg);
      setPopupMessage(msg);
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
      return;
    }

    setMessage("");
    setLoading(true);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/ctc-structure/${companyCode}/employees/download-master-excel`,
        {
          params: {
            companyCode,
            status: selectedStatuses.join(","),
          },
          responseType: "blob",
        },
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      // Adding current date to the filename since month/year are removed
      const today = new Date().toISOString().split("T")[0];
      link.setAttribute("download", `Employee_Muster_Data_${today}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      const successMsg = "Employee Muster Data downloaded successfully!";
      setMessage(successMsg);
      setPopupMessage(successMsg);
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
    } catch (error) {
      console.error("Error downloading report:", error);
      let errorMsg = "Failed to download the report. Please try again.";

      if (
        error.response &&
        error.response.data &&
        error.response.data instanceof Blob
      ) {
        const text = await error.response.data.text();
        try {
          const jsonError = JSON.parse(text);
          if (jsonError.message) errorMsg = jsonError.message;
        } catch (e) {
          console.error("Failed to parse error blob", e);
        }
      } else if (error.response?.data?.message) {
        errorMsg = error.response.data.message;
      }

      setMessage(errorMsg);
      setPopupMessage(errorMsg);
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="pf-report-wrapper">
        <div className="pf-report-container">
          <div className="pf-report-header">
            <h2>Download Employee Muster Data</h2>
            <p>
              Select the company and employee status to generate the report.
            </p>
          </div>

          {/* Applied Flexbox here to align Dropdown left and Checkboxes right */}
          <div
            className="pf-report-form"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              flexWrap: "wrap",
              gap: "20px",
            }}
          >
            <div
              className="pf-form-group"
              style={{ flex: "1", minWidth: "250px" }}
            >
              <label htmlFor="pfCompanyCode" className="inline-label">
                Select Company <span className="required">*</span>
              </label>
              <select
                id="pfCompanyCode"
                value={companyCode}
                onChange={(e) => setCompanyCode(e.target.value)}
              >
                <option value="">-- Select Company --</option>
                {mockCompanies.map((company) => (
                  <option key={company.code} value={company.code}>
                    {company.name} (Code: {company.code})
                  </option>
                ))}
              </select>
            </div>

            <div
              className="pf-form-group"
              style={{ flex: "1", minWidth: "300px" }}
            >
              <label className="inline-label">
                Employee Status <span className="required">*</span>
              </label>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                  height: "40px",
                }}
              >
                <label>
                  <input
                    type="checkbox"
                    name="active"
                    checked={statuses.active}
                    onChange={handleStatusChange}
                  />
                  Active
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="inactive"
                    checked={statuses.inactive}
                    onChange={handleStatusChange}
                  />
                  Inactive
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="dummy"
                    checked={statuses.dummy}
                    onChange={handleStatusChange}
                  />
                  Dummy
                </label>
              </div>
            </div>
          </div>

          {message && (
            <div
              className={`pf-report-message ${
                message.includes("success") ? "success" : "error"
              }`}
            >
              {message}
            </div>
          )}

          <div className="pf-report-actions">
            <button
              className="ctaBtn download-btn"
              onClick={handleDownload}
              disabled={loading}
              style={{ width: "100%", marginTop: "20px" }}
            >
              {loading ? "Generating..." : "Download Employee Muster Data"}
            </button>
          </div>
        </div>
      </div>
      {showPopup && <Popup />}
    </>
  );
};

export default EmployeeMasterData;
